function endsWith(str, a) {
  return str.slice(str.indexOf(a)) === a;
}
// 检测是否为 PC 端
function isPC() {
  return window.innerWidth > 750;
}

class HeaderHandler {
  constructor() {
    const header = document.querySelector("header");
    const for_plugin_tabs = document.querySelector(".for_plugin_tabs");
    if (header && isPC()) {
      this.header = header;
      this.tabs = for_plugin_tabs;
      this.lastScrollTop = 0;
      this.debounceTimer = null;
      window.addEventListener(
        "scroll",
        this.debounce(this.handleScroll.bind(this), 100).bind(this)
      );
    }
  }

  debounce(func, delay) {
    return function () {
      const context = this;
      const args = arguments;
      clearTimeout(this.debounceTimer);
      this.debounceTimer = setTimeout(() => {
        func.apply(context, args);
      }, delay);
    };
  }

  handleScroll() {
    //  const heigt = isPC()  ? 350 : 200;
    const currentScrollTop =
      window.pageYOffset || document.documentElement.scrollTop;
    if (currentScrollTop > this.lastScrollTop) {
      // 向下滚动
      this.header.style.transform = "translateY(-100%)";
      this.header.style.position = "sticky";
      this.tabs.style.top = 0;

      if (isPC() && currentScrollTop > 350) {
        this.tabs.style.display = "block";
      }
    } else {
      // 向上滚动
      this.header.style.transform = "translateY(0)";
      this.tabs.style.top = "103px";
      if (isPC() && currentScrollTop < 350) {
        this.tabs.style.display = "none";
      }
    }
    this.lastScrollTop = currentScrollTop;
  }
}

// 产品详情滚动 自动切换 tabs
function productsObserver() {
  let intersectionObserverConfig = {
    innerHeight: 1200,
    rootMarginTop: 300,
    rootMarginInner: 300,
  };
  if (window.innerWidth < 750) {
    intersectionObserverConfig.innerHeight = 600;
    intersectionObserverConfig.rootMarginTop = 200;
    intersectionObserverConfig.rootMarginInner = 100;
  }
  const windowHeight =
    window.innerHeight > intersectionObserverConfig.innerHeight
      ? window.innerHeight
      : intersectionObserverConfig.innerHeight;
  const lsNm =
    windowHeight -
    intersectionObserverConfig.rootMarginTop -
    intersectionObserverConfig.rootMarginInner;
  const rootMargin =
    "-" +
    intersectionObserverConfig.rootMarginTop +
    "px 0px -" +
    lsNm +
    "px 0px";
  const intersectionObserver = new IntersectionObserver(
    function (entries) {
      entries.forEach((item) => {
        if (item.isIntersecting) {
          // Remove active class from current active element
          const currentActive = document.querySelector(
            ".custom_plugin_style.active"
          );
          if (currentActive) currentActive.classList.remove("active");

          // Add active class to new element
          const targetId = item.target
            .getAttribute("id")
            .replace("plugin_", "");
          const newActive = document.querySelector(
            `a[data-show='${targetId}']`
          );
          if (newActive) {
            newActive.classList.add("active");
            const navTabs = newActive.closest(".nav-tabs");
            if (navTabs) {
              const tabRect = newActive.getBoundingClientRect();
              const navRect = navTabs.getBoundingClientRect();
              if (
                tabRect.left < navRect.left ||
                tabRect.right > navRect.right
              ) {
                newActive.scrollIntoView({
                  behavior: "smooth",
                  block: "nearest",
                  inline: "nearest",
                });
              }
            }
          }
        }
      });
    },
    { rootMargin: rootMargin }
  );

  const description = document.querySelectorAll(".subbox.border-top");
  if (description) {
    description.forEach((plugin_description) => {
      intersectionObserver.observe(plugin_description);
    });
  }
  document
    .querySelector(".for_plugin_tabs")
    .addEventListener("click", function (e) {
      const target = e.target.closest(".custom_plugin_style");
      if (!target) return;
      const data = target.getAttribute("data-show");
      const pluginTarget = document.getElementById("plugin_" + data);
      if (pluginTarget) {
        pluginTarget.style.display = "";
        const detailsCenter = pluginTarget.querySelector(
          ".product-item-details-center"
        );
        if (detailsCenter) detailsCenter.style.display = "";
        const minus = pluginTarget.querySelector(".minus");
        if (minus) minus.style.display = "";
        const add = pluginTarget.querySelector(".add");
        if (add) add.style.display = "none";
      }
    });
  // 点击 tabs 切换
  document
    .querySelector(".product-detail-container")
    .addEventListener("click", function (e) {
      const target = e.target.closest(".product-item-details-h2");
      if (!target) return;
      const add = target.querySelector(".add");
      const minus = target.querySelector(".minus");
      const detailsCenter = target.nextElementSibling;
      detailsCenter.style.display =
        detailsCenter.style.display === "none" ? "" : "none";
      add.style.display = add.style.display === "none" ? "" : "none";
      minus.style.display = minus.style.display === "none" ? "" : "none";
    });
}
function hdCopy() {
  document.querySelectorAll(".action-copy").forEach((button) => {
    button.addEventListener("click", function () {
      const copyButtons = document.querySelectorAll(".action-copy");
      const text = this.getAttribute("data-copy");
      const name = this.getAttribute("data-name");
      document.body.dispatchEvent(
        new CustomEvent("copy:code", {
          detail: {
            code: text,
            name: name,
          },
        })
      );
      if (navigator && navigator.clipboard && text) {
        navigator.clipboard.writeText(text).then(() => {
          copyButtons.forEach((btn) => {
            btn.style.display = "none";
            btn.nextElementSibling.style.display = "";
          });
        });
      } else {
        const textareaEl = document.createElement("textarea");
        textareaEl.setAttribute("readonly", "readonly"); // 防止手机上弹出软键盘
        textareaEl.value = text;
        document.body.appendChild(textareaEl);
        textareaEl.select();
        document.execCommand("copy");
        document.body.removeChild(textareaEl);
        copyButtons.forEach((btn) => {
          btn.style.display = "none";
          btn.nextElementSibling.style.display = "";
        });
      }
    });
  });
}
class RantionProductMedia {
  constructor() {
    this.dom = document.querySelectorAll(".rantion-product-media");
    this.dom.forEach((dom) => {
      dom.childNodes;
      this.hdButton(dom);
      this.hdTabs(dom);
    });
  }
  hdTabs(dom) {
    const productTabs = dom.querySelectorAll(".r-product-tabs");
    if (productTabs) {
      productTabs.forEach((item) => {
        item.addEventListener("control:select", (e) => {
          if (e.detail) {
            const main = item.querySelector(".product-gallery__main");
            if (main && main.childNodes.length > 0) {
              main.childNodes.forEach((item, index) => {
                if (index == e.detail.index) {
                  item.classList.remove("rantion-hidden");
                } else {
                  item.classList.add("rantion-hidden");
                }
              });
            }
          }
        });
      });
    }
  }
  hdButton(dom) {
    // 绑定 下方的 视频 图片 切换按钮
    const main_product_bottom = dom.querySelector(".main_product_bottom");
    const main_product_button = dom.querySelectorAll(".main_product_button");
    if (main_product_bottom) {
      main_product_bottom.addEventListener("click", (e) => {
        const target = e.target.closest(".main_product_button");
        main_product_button.forEach(function (item) {
          item.classList.remove("product_active");
        });
        if (target) {
          const type = target.dataset.type;
          target.classList.add("product_active");
          if (type) {
            document.querySelectorAll(".r-product-tabs").forEach((a) => {
              if (a.classList.contains(type)) {
                a.classList.remove("rantion-hidden");
              } else {
                a.classList.add("rantion-hidden");
              }
            });
          }
        }
      });
    }
  }
}
class Recommendations {
  constructor() {
    const recommendations = document.querySelectorAll(
      ".product-recommendations"
    );
    this.recommendationsList = recommendations;
    Array.from(recommendations).forEach((item) => {
      this.onChange(item);
      this.page(item);
    });
  }
  tagPage(dom, data) {
    dom.setAttribute("data-current", data.next);
    const forms = dom.querySelectorAll(".accessory-item");
    Array.from(forms).forEach((item, k) => {
      const startIndex = data.size * (data.next - 1);
      const endIndex = startIndex + data.size;
      if (k >= startIndex && k < endIndex) {
        item.classList.remove("rantion-hidden"); // 显示当前页的元素
      } else {
        item.classList.add("rantion-hidden"); // 隐藏非当前页的元素
      }
    });
  }
  page(recommendations) {
    recommendations.addEventListener("click", (e) => {
      const totalDom = recommendations.querySelector(".recommendations-title");
      const prvDom = recommendations.querySelector(".goto-prv");
      const nextDom = recommendations.querySelector(".goto-next");
      const target = e.target.closest(".goto");
      if (target && totalDom) {
        let action = target.dataset.action;
        const current = parseInt(recommendations.dataset.current, 10);
        const size = parseInt(recommendations.dataset.size, 10);
        const total = parseInt(totalDom.dataset.total, 10);
        const num = Math.ceil(total / size); // 向上取整以处理不能整除的情况
        if (action === "next") {
          const next = current + 1;
          if (next === num) {
            nextDom.classList.add("rantion-hidden");
            prvDom.classList.remove("rantion-hidden");
          } else {
            prvDom.classList.remove("rantion-hidden");
          }
          this.tagPage(recommendations, {
            next: next,
            size: size,
          });
        } else {
          const next = current - 1;
          if (next === 1) {
            prvDom.classList.add("rantion-hidden");
            nextDom.classList.remove("rantion-hidden");
          } else {
            nextDom.classList.remove("rantion-hidden");
          }
          this.tagPage(recommendations, {
            next: next,
            size: size,
          });
        }
      }
    });
  }
  onChange(recommendations) {
    /**
     * 产品推荐 选中 把数量默认设置为 1
     * 解决 选中推荐产品后 数量为 0 的问题
     */
    recommendations.addEventListener("change", function (e) {
      const _this = e.target;
      const variant_id = _this.getAttribute("data-variant_id");
      if (variant_id) {
        const qty = recommendations.querySelector(
          '.quantity-selector__input[data-variant_id="' + variant_id + '"]'
        );
        if (_this.checked && qty.value == 0) {
          qty.value = 1;
        }
      }
    });
  }
}
class Detail {
  constructor() {
    try {
      const productJsonElement = document.querySelector("[data-product-json]");
      if (productJsonElement) {
        const jsonData = JSON.parse(productJsonElement.innerHTML);
        const selected_sku = jsonData.product.variants.find((item) => {
          return item.id == jsonData.selected_variant_id;
        });
        this.tabDetail(selected_sku.sku);
      }
    } catch (error) {
      console.log(error);
    }
    document.addEventListener("variant:change", (res) => {
      this.tabDetail(res.detail.variant.sku);
    });
  }
  tabDetail(sku) {
    document.querySelectorAll("[data-skudetails]").forEach((dom) => {
      dom.classList.remove("on");
      const skudetails = dom.getAttribute("data-skudetails");
      if (skudetails && skudetails.split(",").includes(sku)) {
        dom.classList.add("on");
      }
    });
  }
}

// 处理 被 shopify 删除的 自定义组件
class RantionSwiper {
  constructor() {
    this.swipers = document.querySelectorAll(".rantion-swiper");
    this.init();
  }

  init() {
    this.swipers.forEach((swiper) => {
      const isValue = swiper.getAttribute("is");
      if (isValue == "") {
        swiper.removeAttribute("is");
      }
      if (swiper.hasAttribute("is")) {
        return;
      }
      // 创建轮播容器
      const wrapper = document.createElement("div");
      wrapper.className = "rantion-swiper-wrapper";

      // 获取所有轮播项
      const slides = swiper.querySelectorAll(".rantion-swiper-slide");
      const slideCount = slides.length;

      // 将原有的轮播项移动到新容器中
      slides.forEach((slide, index) => {
        const isValue = slide.getAttribute("is");
        if (isValue == "") {
          slide.removeAttribute("is");
        }
        wrapper.appendChild(slide);
        slide.style.transform = `translateX(${index * 100}%)`;
      });

      // 添加轮播容器到主容器
      swiper.appendChild(wrapper);

      // 创建指示器容器
      const indicators = document.createElement("div");
      indicators.className = "rantion-swiper-indicators";

      // 添加指示器
      for (let i = 0; i < slideCount; i++) {
        const dot = document.createElement("span");
        dot.className = "rantion-swiper-indicator";
        if (i === 0) dot.classList.add("active");
        dot.addEventListener("click", () => this.goToSlide(swiper, i));
        indicators.appendChild(dot);
      }

      // 添加指示器到主容器
      swiper.appendChild(indicators);

      // 添加导航按钮
      const prevBtn = document.createElement("button");
      prevBtn.className = "rantion-swiper-prev";
      prevBtn.innerHTML = "❮";
      prevBtn.addEventListener("click", () => this.prevSlide(swiper));

      const nextBtn = document.createElement("button");
      nextBtn.className = "rantion-swiper-next";
      nextBtn.innerHTML = "❯";
      nextBtn.addEventListener("click", () => this.nextSlide(swiper));

      swiper.appendChild(prevBtn);
      swiper.appendChild(nextBtn);

      // 初始化状态
      swiper.dataset.currentSlide = "0";

      // 启动自动播放
      this.startAutoplay(swiper);
    });
  }

  goToSlide(swiper, index) {
    const wrapper = swiper.querySelector(".rantion-swiper-wrapper");
    const slides = wrapper.querySelectorAll(".rantion-swiper-slide");
    const indicators = swiper.querySelectorAll(".rantion-swiper-indicator");

    // 更新轮播位置
    slides.forEach((slide, i) => {
      slide.style.transform = `translateX(${(i - index) * 100}%)`;
    });

    // 更新指示器状态
    indicators.forEach((dot, i) => {
      dot.classList.toggle("active", i === index);
    });

    // 更新当前索引
    swiper.dataset.currentSlide = index.toString();
  }

  nextSlide(swiper) {
    const currentIndex = parseInt(swiper.dataset.currentSlide);
    const slides = swiper.querySelectorAll(".rantion-swiper-slide");
    const nextIndex = (currentIndex + 1) % slides.length;
    this.goToSlide(swiper, nextIndex);
  }

  prevSlide(swiper) {
    const currentIndex = parseInt(swiper.dataset.currentSlide);
    const slides = swiper.querySelectorAll(".rantion-swiper-slide");
    const prevIndex = (currentIndex - 1 + slides.length) % slides.length;
    this.goToSlide(swiper, prevIndex);
  }

  startAutoplay(swiper) {
    setInterval(() => {
      this.nextSlide(swiper);
    }, 5000); // 每5秒切换一次
  }
}

function init() {
  productsObserver();
  hdCopy();
  new Detail();
  new HeaderHandler();

  // 产品多媒体
  new RantionProductMedia();

  // 相关产品 推荐
  new Recommendations();
  const tgoto = document.querySelector(".goto-top");
  if (tgoto) {
    tgoto.addEventListener("click", function (e) {
      e.preventDefault();
      const target = document.querySelector(".product-detail-container");
      if (target) {
        target.scrollIntoView({
          behavior: "smooth",
          block: "start",
        });
      }
    });
  }
}

function ready(callback) {
  if (
    document.readyState === "interactive" ||
    document.readyState === "complete"
  ) {
    callback();
  } else {
    document.addEventListener("DOMContentLoaded", callback);
  }
}
ready(init);
